import { createContext } from "react"

export const AdminSubmissionContext = createContext()
